import { Typography } from "@tm/components"

type Props = {
    warehouseName?: string
    distributorName?: string
}

export function OrderOptionsGroupDescription({ warehouseName, distributorName }: Props) {
    if (!warehouseName && !distributorName) {
        return null
    }

    let description = distributorName
    if (description && warehouseName) {
        description += ` - ${warehouseName}`
    } else if (warehouseName) {
        description = warehouseName
    }

    return (
        <Typography order={-1} variant="body1" color="primary" fontWeight="bold" marginRight="1rem">
            {description}
        </Typography>
    )
}
